<!-- @format -->

<invoice-list>
  <table class="contents_table">
    <tbody>
      <tr class="column_invoices-crocodesk">
        <th class="number">
          <div class="sort-cel">
            請求番号
            <div
              if="{ props.orderBy }"
              class="{ props.orderBy == 'asc' ? 'button_sort-ascend' : 'button_sort-descend' }"
              onclick="{ e => props.setOrderBy(props.orderBy == 'asc' ? 'desc' : 'asc') }"
            ></div>
          </div>
        </th>
        <th class="date-bill">請求日</th>
        <th class="date-payment">支払期限</th>
        <th class="method">支払方法</th>
        <th class="price">請求金額（税込）</th>
        <th class="status">ステータス</th>
        <th class="bill">請求書</th>
      </tr>

      <tr each="{ invoice in props.list }">
        <td>
          <a
            class="link_outer"
            onclick="{ e => detail(e,invoice) }"
            target="_blank"
          >
            { invoice.id }
          </a>
        </td>
        <td>{ invoice.invoiced_at }</td>
        <td>{ invoice.payment_due_date }</td>
        <td></td>
        <td>{ Number(invoice.price).toLocaleString() }円</td>
        <td>
          <span class="{InvoiceStatus(invoice.status).class}">
            {InvoiceStatus(invoice.status).text}
          </span>
        </td>
        <td>
          <button
            class="button button-secondary-mini button-download"
            type="button"
            value="PDF"
            onclick="{ e => pdf(e,invoice) }"
          >
            PDF
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <!--/.contents_table-->

  <script>
    import Status from "@model/status.js";
    export default {
      InvoiceStatus: Status.invoice,
      pdf(e, invoice) {
        window.open(invoice.pdf_link, `invoice-pdf-${invoice.id}`);
      },
      detail(e, invoice) {
        window.open(invoice.detail_link, `invoice-${invoice.id}`);
      }
    };
  </script>
</invoice-list>
